angular.module('rjmNg.directives').directive "emailScheduler", [
  () ->
    restrict: "E"
    templateUrl: "directive.emailScheduler.html"
    replace: false
    controllerAs: "view"
    bindToController: true
    scope:
      onUpdate: "&"
      emailSchedule: "<"
    controller: [
      "EmailSummary"
      "emailSummaryEnums"
      (
        EmailSummary
        emailSummaryEnums
      ) ->

        view = @

        _allFreq = []
        _realFreq = null
        _repeatingFrequency = {
            key: -1,
            code: 'repeating',
            display_name: 'Repeating'
          }

        view.aMpMOptions = _.map(emailSummaryEnums.AM_PM_OPTIONS, (x) -> {name: x})
        view.end = null
        view.frequencyOptions = []
        view.hasEnd = false
        view.hourOptions = _.map(emailSummaryEnums.HOUR_OPTIONS, (x) -> {name : x})
        view.minuteOptions = _.map(emailSummaryEnums.MINUTE_OPTIONS, (x) -> {name : x})
        view.repeatingOptions = []
        view.selectedAmPm = {name: 'AM'}
        view.selectedFrequency = null
        view.selectedHour = {name: 12}
        view.selectedMinute = {name: '00'}
        view.selectedRepeatingFrequency = null
        view.showEnd = false
        view.showRepeatFrequency = false
        view.showStart = false
        view.start = null

        _endAfterStart = () ->
          result = true
          if(view.end and view.start)
            result = moment(view.end).isAfter(view.start)
          view.endError = !result
          return result

        _hideEnd = () ->
          view.showEnd = false
          view.hasEnd = false
          view.end = null

        _hideRepeatFrequency = () ->
          view.showRepeatFrequency = false
          view.selectedRepeatingFrequency = null

        _hideStart = () ->
          view.showStart = false
          view.selectedAmPm = {name: 'AM'}
          view.selectedHour = {name: 12}
          view.selectedMinute = {name: '00'}
        
        _getSchedule = () ->
          _tmpTime = moment(view.selectedHour.name + ':' + view.selectedMinute.name + ' ' + view.selectedAmPm.name, 'HH:mm A')
          return {
            frequency: _realFreq?.key,
            start_date: if(_realFreq?.key is 0) then null else view.start,
            end_date: if(_realFreq?.key is 0 or _realFreq?.key is 1) then null else view.end,
            dispatch_time: if(_realFreq?.key is 0) then null else _tmpTime.format('HH:mm')
          }

        _initSchedule = () ->
          # check for repeating options length length and repeating options to ensure things loaded
          if(view.emailSchedule?.frequency? && view.repeatingOptions.length > 0)
            if(view.emailSchedule.end_date)
              view.hasEnd = true
              view.end = view.emailSchedule.end_date

            if(view.emailSchedule.start_date)
              view.start = view.emailSchedule.start_date

            if(view.emailSchedule.dispatch_time)
              _dt = moment(view.emailSchedule.dispatch_time, 'HH:mm')
              view.selectedAmPm = {name: _dt.format('A')}
              view.selectedHour = {name: _dt.format('h')}
              view.selectedMinute = {name: _dt.format('mm')}
            
            _setFreq = _.find(_allFreq, (opt) ->
              return opt.key is view.emailSchedule.frequency
            )
            # call set frequency last so correct fields are visible and validate is called
            view.setFrequency(_setFreq)

        _showStart = () ->
          view.showStart = true
          if (!view.start) then view.start = moment().format('YYYY-MM-DD')

        _validateSchedule = () ->
          isValid = false
          _endAfterStart()
          if(_realFreq?.key?)
            if(_realFreq.key is 0)
              isValid = true
            else
              if(view.start && !view.hasEnd || (view.end && !view.endError))
                isValid = true
              else 
                isValid = false
          else
            isValid = false

          view.onUpdate({isValid: isValid, emailSchedule: _getSchedule()})

        view.setAmPm = (item) ->
          view.selectedAmPm = item
          _validateSchedule()

        view.setFrequency = (item) ->
          if(item)
            switch(item.key)
              when -1 
                view.selectedFrequency = item
                _realFreq = null
                view.showEnd = true
                view.showRepeatFrequency = true
                _showStart()
              when 0
                view.selectedFrequency = item
                _realFreq = item
                _hideEnd()
                _hideStart()
                _hideRepeatFrequency()
              when 1
                view.selectedFrequency = item
                _realFreq = item
                _hideEnd()
                _hideRepeatFrequency()
                _showStart()
              else
                if(item.key >= 2)
                  view.selectedFrequency = _repeatingFrequency
                  view.selectedRepeatingFrequency = _realFreq = item
                  view.showEnd = true
                  view.showRepeatFrequency = true
                  _showStart()
          
          _validateSchedule()

        view.setHasEnd = (hasEnd) ->
          view.hasEnd = hasEnd
          if(!hasEnd)
            view.end = null
          else
            _tmpEnd = moment(view.start)
            _tmpEnd.add(1, 'day')
            view.setEnd(_tmpEnd.format('YYYY-MM-DD'))
          _validateSchedule()

        view.setHour = (item) ->
          view.selectedHour = item
          _validateSchedule()

        view.setMinute = (item) ->
          view.selectedMinute = item
          _validateSchedule()

        view.setStart = (startDate) ->
          view.start = startDate
          _validateSchedule()

        view.setEnd = (endDate) ->
          view.end = endDate
          _validateSchedule()

        view.$onChanges = (changeObj) ->
          if(changeObj.emailSchedule and not angular.equals(changeObj.emailSchedule.currentValue, changeObj.emailSchedule.previousValue))
            _initSchedule()

        view.$postLink = () ->
          view.loading = true;
          EmailSummary.getMetaData().then((success)->
            _allFreq = success.data.schedule_frequencies
            view.frequencyOptions = _.filter(_allFreq, (freq) -> 
              return freq.code.indexOf('repeating') is -1 
            )
            view.frequencyOptions.push(_repeatingFrequency)
            view.repeatingOptions = _.filter(_allFreq, (freq) ->
              return freq.code.indexOf('repeating') isnt -1 
            )
            _initSchedule()
          ,(error) ->
            console.log(error)
          ).finally(() ->
            view.loading = false
          )
        return view
    ]

]
